module.exports = __webpack_public_path__ + "static/media/relay-initial-load.c6af5327.gif";